import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { setUser } from "store/auth/authSlice";

const AdminLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post("/auth/admin-login", formData);
      dispatch(setUser({ token: res.data.token, ...res.data.user }));
      toast.success("Login Successful");
      navigate("/questions-list", { replace: true });
    } catch (err) {
      console.log(err);
      const message =
        err.response?.data?.errors?.[0] || "Uh Oh! Something went wrong";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4 sm:px-6">
      {/* Background */}
      <img src="/assets/imgs/bg.jpg" alt="" className="fixed inset-0 h-full w-full object-cover -z-10" />

      <div className="w-full max-w-md sm:max-w-lg">
        <div className="text-center mb-6 sm:mb-8">
          <div className="inline-block p-2.5 rounded-2xl bg-white/60 backdrop-blur mb-4 ring-1 ring-emerald-200/30">
            <img
              className="h-16 sm:h-20 w-auto object-contain drop-shadow-lg"
              src="/assets/imgs/UbayNewLogo.png"
              alt="Ubay logo"
            />
          </div>
        </div>

        <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl px-6 sm:px-8 py-8 sm:py-10 shadow-2xl">
          <h3 className="text-center font-bold text-2xl sm:text-3xl text-slate-900 mb-6 sm:mb-8">Admin Login</h3>

          <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-slate-700 mb-1.5"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2.5 sm:py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all bg-white/60 text-base"
                placeholder="admin@example.com"
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-slate-700 mb-1.5"
              >
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                value={formData.password}
                onChange={handleChange}
                className="w-full px-4 py-2.5 sm:py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all bg-white/60 text-base"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-emerald-600 text-white py-2.5 sm:py-3 px-4 rounded-xl hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all font-semibold text-base sm:text-lg shadow-md hover:shadow-lg"
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
